var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36792 5.73641L1.6945 5.63454C2.89402 2.46855 6.33794 0.665309 9.69567 1.56186C13.2719 2.51677 15.3962 6.17275 14.4403 9.7277C13.4844 13.2827 9.81034 15.3904 6.23407 14.4356C3.57873 13.7265 1.72388 11.5284 1.33594 8.9883",
    stroke: "#595959",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33203V7.9987L9.33333 9.33203",
    stroke: "#595959",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeHistory);
export default __webpack_public_path__ + "static/media/TimeHistory.33d518ebd3544bf094ffe750da4f8c5d.svg";
export { ForwardRef as ReactComponent };